import * as Select from '@studio/design-system/select';
import type { ReactElement } from 'react';
import { Column, Exhibit } from './styled.jsx';

/** `<Selects>` exhibit. */
export const Selects = (): ReactElement => (
  <Exhibit title='Selects'>
    <div className='flex gap-40'>
      {(['sm', 'md', 'lg', 'xl'] as const).map((size) => (
        <Column key={size}>
          <div className='font-bold'>{size.toUpperCase()}</div>

          <Select.Root size={size}>
            <Select.Trigger>
              <Select.Value placeholder='Select a fruit…' />
            </Select.Trigger>

            <Select.Content>
              <Select.Item value='apple'>Apple</Select.Item>
              <Select.Item value='banana'>Banana</Select.Item>
              <Select.Item value='cranberry'>Cranberry</Select.Item>
              <Select.Item value='fig'>Fig</Select.Item>
              <Select.Item value='grape'>Grape</Select.Item>
              <Select.Item value='huckleberry'>Huckleberry</Select.Item>
              <Select.Item value='kiwi'>Kiwi</Select.Item>
              <Select.Item value='lemon'>Lemon</Select.Item>
              <Select.Item value='mango'>Mango</Select.Item>
              <Select.Item value='nectarine'>Nectarine</Select.Item>
              <Select.Item value='orange'>Orange</Select.Item>
              <Select.Item value='pear'>Pear</Select.Item>
              <Select.Item value='quince'>Quince</Select.Item>
              <Select.Item value='raspberry'>Raspberry</Select.Item>
              <Select.Item value='starfruit'>Starfruit</Select.Item>
              <Select.Item value='tangelo'>Tangelo</Select.Item>
              <Select.Item value='ugli-fruit'>Ugli Fruit</Select.Item>
              <Select.Item value='watermelon'>Watermelon</Select.Item>
            </Select.Content>
          </Select.Root>

          <Select.Root size={size}>
            <Select.Trigger>
              <Select.Value placeholder='Select a vegetable…' />
            </Select.Trigger>

            <Select.Content>
              <Select.Item value='asparagus'>Asparagus</Select.Item>
              <Select.Item value='broccoli'>Broccoli</Select.Item>
              <Select.Item value='carrot'>Carrot</Select.Item>
              <Select.Item value='eggplant'>Eggplant</Select.Item>
              <Select.Item value='fennel'>Fennel</Select.Item>
            </Select.Content>
          </Select.Root>
        </Column>
      ))}
    </div>
  </Exhibit>
);
